import {
    INDICACOES_CREATE_LOAD,
    INDICACOES_CREATE_ERROR,
    INDICACOES_CREATE_SUCCESS,
    INDICACOES_LOAD,
    INDICACOES_SUCCESS,
    INDICACOES_ERROR,
    INDICACAO_LOAD,
    INDICACAO_SUCCESS,
    INDICACAO_ERROR,
    INDICACOES_RESET,
    CLEAR_MESSAGE,
    REFERRALS_LOAD,
    REFERRALS_SUCCESS,
    REFERRALS_ERROR,
    REFERRAL_CODE_LOAD,
    REFERRAL_CODE_SUCCESS,
    REFERRAL_CODE_ERROR,
    COMMISSIONS_LOAD,
    COMMISSIONS_SUCCESS,
    COMMISSIONS_ERROR,
    WITHDRAWALS_LOAD,
    WITHDRAWALS_SUCCESS,
    WITHDRAWALS_ERROR
} from '../actionTypes'

import { API_URL, request } from '../../utils/api'

export const actionClearMessage = () => {
    return {
        type: CLEAR_MESSAGE
    }
}

export const resetIndicacaoForm = () => {
    return {
        type: INDICACOES_RESET
    }
}

export const loadIndicacoes = (userid) => {
    return dispatch => {
        dispatch({
            type: INDICACOES_LOAD
        })

        request(`/indicacoes/${userid}`, 'GET')
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: INDICACOES_SUCCESS,
                    payload: {
                        indicacoes: response.data || []
                    }
                })
            } else {
                throw new Error(response.message || 'Erro ao carregar indicações')
            }
        })
        .catch(error => {
            console.error('Erro ao carregar indicações:', error);
            dispatch({
                type: INDICACOES_ERROR,
                payload: {
                    message: error.message
                }
            })
        })
    }
}

export const loadIndicacao = (id) => {
    return dispatch => {
        dispatch({
            type: INDICACAO_LOAD
        })

        request(`/indicacao/${id}`, 'GET')
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: INDICACAO_SUCCESS,
                    payload: {
                        indicacao: response.data || {}
                    }
                })
            } else {
                throw new Error(response.message || 'Erro ao carregar indicação')
            }
        })
        .catch(error => {
            console.error('Erro ao carregar indicação:', error);
            dispatch({
                type: INDICACAO_ERROR,
                payload: {
                    message: error.message
                }
            })
        })
    }
}

export const createIndicacao = (data) => {
    return dispatch => {
        dispatch({
            type: INDICACOES_CREATE_LOAD
        })

        return new Promise((resolve, reject) => {
            request(`/indicacoes`, 'POST', data)
            .then(response => {
                if (response.status === 200) {
                    dispatch({
                        type: INDICACOES_CREATE_SUCCESS,
                        payload: {
                            message: 'Indicação criada com sucesso!'
                        }
                    })
                    resolve(response.data)
                } else {
                    throw new Error(response.message || 'Erro ao criar indicação')
                }
            })
            .catch(error => {
                console.error('Erro ao criar indicação:', error);
                dispatch({
                    type: INDICACOES_CREATE_ERROR,
                    payload: {
                        message: error.message
                    }
                })
                reject(error)
            })
        })
    }
}

export const loadReferrals = (userId, page = 1, limit = 100) => {
    return dispatch => {
        dispatch({
            type: REFERRALS_LOAD
        })

        const url = `users/referrals/${userId}`;
        console.log('Carregando referidos:', url);

        request(url, 'GET')
        .then(response => {
            console.log('Resposta da API (referrals):', response);
            if (response.code === 200) {
                const data = response.data || {};
                
                const referralData = {
                    user: data.user || {},
                    balance: data.stats && data.stats.balance ? data.stats.balance : {
                        totalBalance: 0,
                        availableBalance: 0,
                        pendingBalance: 0,
                        withdrawnBalance: 0,
                        lastUpdated: null
                    },
                    referralStats: data.stats || { 
                        totalDirectReferrals: 0,
                        totalIndirectReferrals: 0,
                        totalActiveReferrals: 0,
                        totalReferrals: 0
                    },
                    commissionStats: {
                        totalPendingCommissions: data.stats ? data.stats.totalPendingCommissions || 0 : 0,
                        totalApprovedCommissions: data.stats ? data.stats.totalApprovedCommissions || 0 : 0,
                        totalEarnings: data.stats ? data.stats.totalEarnings || 0 : 0,
                        availableBalance: data.stats ? data.stats.availableBalance || 0 : 0
                    },
                    directReferrals: data.referrals || [],
                    recentCommissions: data.recentCommissions || []
                };
                
                const paginationData = {
                    total: referralData.referralStats.totalReferrals || 0,
                    page: 1,
                    limit: 100,
                    totalPages: 1
                };
                
                const referralCode = data.userReferralCode || 'ABC123';
                
                const referralLink = `${window.location.origin}/cadastro?referralCode=${referralCode}`;
                
                dispatch({
                    type: REFERRALS_SUCCESS,
                    payload: {
                        referralData: referralData,
                        referrals: referralData.directReferrals,
                        pagination: paginationData,
                        referralCode: referralCode,
                        referralLink: referralLink
                    }
                })
            } else {
                throw new Error(response.message || 'Erro ao carregar referidos')
            }
        })
        .catch(error => {
            console.error('Erro ao carregar referidos:', error);
            dispatch({
                type: REFERRALS_ERROR,
                payload: {
                    message: error.message
                }
            })
        })
    }
}

export const loadCommissions = (userId, page = 1, limit = 10, status = '') => {
    return dispatch => {
        dispatch({
            type: COMMISSIONS_LOAD
        })

        let url = `referrals/commissions/${userId}?page=${page}&limit=${limit}`;
        if (status) {
            url += `&status=${status}`;
        }
        
        console.log('Carregando comissões:', url);

        request(url, 'GET')
        .then(response => {
            console.log('Resposta da API (comissões):', response);
            if (response.code === 200) {
                dispatch({
                    type: COMMISSIONS_SUCCESS,
                    payload: {
                        commissions: response.data || [],
                        pagination: response.pagination || {
                            total: 0,
                            page: page,
                            limit: limit,
                            totalPages: 0
                        }
                    }
                })
            } else {
                throw new Error(response.message || 'Erro ao carregar comissões')
            }
        })
        .catch(error => {
            console.error('Erro ao carregar comissões:', error);
            dispatch({
                type: COMMISSIONS_ERROR,
                payload: {
                    message: error.message
                }
            })
        })
    }
}

export const loadWithdrawals = (userId, page = 1, limit = 10, status = '') => {
    return dispatch => {
        dispatch({
            type: WITHDRAWALS_LOAD
        })

        const queryParams = new URLSearchParams({
            page,
            limit,
            ...(status && { status })
        }).toString();

        const url = `resgates/meus-saques${queryParams ? `?${queryParams}` : ''}`;
        
        request(url, 'GET')
        .then(response => {
            console.log('Resposta da API (saques):', response);
            if (response.code === 200 || response.code === 51 || response.status === 200) {
                // Handle both old and new API response formats
                let withdrawals = [];
                let pagination = {};
                
                // New API format (code 51 with saques array and pagination object)
                if (response.code === 51 && response.saques) {
                    withdrawals = response.saques;
                    pagination = response.pagination || {};
                } 
                // Old API format
                else {
                    const data = response.data || {};
                    withdrawals = Array.isArray(data) ? data : (data.saques || []);
                    pagination = {
                        total: data.total || data.length || 0,
                        page: data.page || page,
                        limit: data.limit || limit,
                        totalPages: data.totalPages || Math.ceil((data.total || data.length) / limit)
                    };
                }
                
                const withdrawalsData = {
                    withdrawals,
                    pagination
                };
                
                dispatch({
                    type: WITHDRAWALS_SUCCESS,
                    payload: withdrawalsData
                })
            } else {
                throw new Error(response.message || 'Erro ao carregar histórico de saques')
            }
        })
        .catch(error => {
            console.error('Erro ao carregar histórico de saques:', error);
            dispatch({
                type: WITHDRAWALS_ERROR,
                payload: {
                    message: error.message
                }
            })
        })
    }
} 